import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCurrencyYen: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCurrencyYen"><Path d="M19.5117 4.10547L18.7031 5.05859L14.1309 10.4502H18V12.9502H13.25V14.5H18V17H13.25V21H10.75V17H6V14.5H10.75V12.9502H6V10.4502H9.86914L5.29688 5.05859L4.48828 4.10547L6.39453 2.48828L7.20312 3.44141L12 9.09766L16.7969 3.44141L17.6055 2.48828L19.5117 4.10547Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCurrencyYen;
